// removed by extract-text-webpack-plugin
module.exports = {"editButton":"UsersTable-editButton"};